export const skLocale = {
	months: [
		"Január",
		"Február",
		"Marec",
		"Apríl",
		"Máj",
		"Jún",
		"Júl",
		"August",
		"September",
		"Október",
		"November",
		"December",
	],
	monthsShort: ["Jan", "Feb", "Mar", "Apr", "Máj", "Jún", "Júl", "Aug", "Sep", "Okt", "Nov", "Dec"],
	weekdays: ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"],
	weekdaysShort: ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"],
	weekdaysMin: ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"],
	longDateFormat: {
		LT: "H:mm",
		LTS: "H:mm:ss",
		L: "DD.MM.YYYY",
		LL: "D. MMMM YYYY",
		LLL: "D. MMMM YYYY H:mm",
		LLLL: "dddd D. MMMM YYYY H:mm",
	},
	calendar: {
		sameDay: "[Dnes o] LT",
		nextDay: "[Zajtra o] LT",
		nextWeek: "dddd [o] LT",
		lastDay: "[Včera o] LT",
		lastWeek: "[Minulý] dddd [o] LT",
		sameElse: "L",
	},
	relativeTime: {
		future: "o %s",
		past: "pred %s",
		s: "niekoľko sekúnd",
		ss: "%d sekúnd",
		m: "minúta",
		mm: "%d minút",
		h: "hodina",
		hh: "%d hodín",
		d: "deň",
		dd: "%d dní",
		M: "mesiac",
		MM: "%d mesiacov",
		y: "rok",
		yy: "%d rokov",
	},
	dayOfMonthOrdinalParse: /\d{1,2}\./,
	ordinal: (n: number) => `${n}.`,
	week: {
		dow: 1, // Monday is the first day of the week.
		doy: 4, // The week that contains Jan 4th is the first week of the year.
	},
};
